//users EndPoints
export const USER = `users/`;
export const DELETE_USER = `users/`;
export const UPDATE_USER = `users/`;
export const CREATE_USER = `users/create-user`;
export const LIST_USERS = `users/`;
export const DETAIL_USER = `users/user-details/?userid=`;
export const INVITATION_USER = "users/send-invitation";
export const ALL_USERS = `users/all`;
export const INPERSONATE = `impersonation-users`;
//customers Endpoints
export const CUSTOMERS = `customers/all`;
export const GET_CUSTOMER = `customers/`;
export const DELETE_CUSTOMER = `customers/`;
export const INVITATION_CUSTOMER = `users/send-invitation`;
export const UPDATE_INFO_CUSTOMER = `customers/`;
export const CUSTOMER = `customers/`;
export const ALL_GROUP_USER = `customers/:customer_id/user-groups`;
export const ADDRESSES = `/addresses`;
export const USERS = `/users`;
export const DOCUMENT = `/document`;
export const DOCUMENTS = `/documents`;
export const DOCUMENT_GROUP = `/document-group`;
export const DOCUMENT_GROUPS = `/document-groups`;
export const USER_GROUP = `/user-group`;
export const USER_GROUPS = `/user-groups`;

//Role Endpoints
export const ALL_ROLE = `roles/get-user-role/?userid=`;
export const CREATE_ROLE = `roles/create-user-role`;
export const UPDATE_ROLE = `roles/update-user-role`;
//Group Documents Endpoints
export const GET_BY_ID_DOCUMENT_GROUP = `document-groups/`;
export const UPDATE_DOCUMENT_GROUP = `document-groups/`;
export const ALL_GROUPS = `groups/all`;
export const DELETE_GROUPS = `document-groups/`;
export const CREATE_GROUP_DOCUMENTS = `groups/save`;
export const ASSIGN_DOCUMENT_GROUP = `documents/assign-document-group`;
export const DOCUMENT_GROUP_HIERARCHICAL = `/document-groups/hierarchical`;
//Ducument Endpoints
export const DOCUMENT_ADD = `documents/`;
export const ALL_DOCUMENT = `documents/all`;
export const DOCUMENT_DOWNLOAD = `documents/`;
export const DELETE_DOCUMENT = `documents/`;
export const USER_PERMISSION = `/user-permissions`;
export const USER_GROUP_PERMISSION = `/user-group-permissions`;
// User Group Endpoints
export const GET_GROUP_BYID = `user-groups/`;
export const CREATE_GROUP = `user-groups/`;
export const UPDATE_USER_GROUP = `user-groups/`;
export const USER_GROUP_DELETE = `user-groups/`;
export const ASSIGN_USER_GROUP = `users/assign-user-group`;
//FTP Endpoints
export const FTP_USER = `ftp/users/`;
export const FTP_PROCESS_URL = `/process-url`;
//Permission Endpoints
export const PERMISSION = `permisions/document`;
export const PERMISSION_DOCUMENT_GROUP = `permisions/document-group`;
export const PERMISSIONS = `permisions/`;
export const USER_DELETE = `/user`;
export const HARD_DELETE = `/hard-delete`;
